<script>
import { Components } from '../layout'

export default {
  props: ['extra', 'isPage', 'menu'],

  render(h) {
    const children = []
    const extra = this.extra
    ;(extra.children || []).forEach(child => {
      if (child.visible) {
        let component = Components[child.options.kind] || Components['unknown']
        let element = h(component, { props: { extra: child, isPage: this.isPage, menu: this.menu } })
        children.push(h('v-flex', { class: `${child.options.add_class || ''} ${extra.options.add_child_class || ''}` }, [element]))
      }
    })
    if (children.length) {
      const layout = h('v-layout', { class: 'row wrap' }, children)
      if (extra.options.show_panel_title || extra.options.wrapper && extra.options.wrapper.indexOf('panel') > -1) {
        const title = extra.options.show_panel_title ? h('v-card-title', { class: 'title grey lighten-4' }, extra.name) : null
        return h('v-card', { class: "mb-3" }, [title, h('v-card-text', [layout])])
      } else {
        return layout
      }
    }
  }
}
</script>
